import { ZoekDocumentZittingComponent } from './zoek-document-zitting/zoek-document-zitting.component';
import { Routes } from '@angular/router';

export const zoekenZittingRoutes: Routes = [
    { path: 'zoekdocumentzitting', component: ZoekDocumentZittingComponent  }
]
